import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';
import { merge } from 'lodash';
import LoaderTypes from './mixins/Loader';

const namespace = 'Recruitomat';

const Types = merge(
    {
        mutations: {
            SET_PREDICTIONS: 'setPredictions',
        },
        actions: {
            LOAD_PREDICTIONS: 'loadPredictions',
            LOAD_CUSTOM_PREDICTIONS: 'loadCustomPredictions',
        },
    },
    LoaderTypes,
);

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
